export const LADE_AUSWAHLWERTE_NEWS =
	"ladeAuswahlwerteNews";
